import {LimitRegistry} from './LimitRegistry';

export class UserLimit {

  name: string | null = null;
  actualValue = 0;
  maxValue = 0;
  limits: Array<LimitRegistry> = [];

}
